import {Request} from './model/request';
import {Utils} from "../utils/utils";

export class FetchService {

    public static executeEndpoint(request: Request): void {
        const xhr = new XMLHttpRequest();
        let url=request.getUrl();
        if(!url.startsWith("http")){
            url=Utils.getAppLink()+url;
        }
        xhr.open(request.getMethod(), url);
        if (!request.getIsRefresh()) {
            const access_token = this.getAccessToken();
            if (!access_token) {
                if (request.getFail()) {
                    request.getFail()("Su sesi�n ha caducado. Vuelva a ingresar");
                }
                //Utils.redirectOnSessionError();
                return;
            }
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.getAccessToken());
        }
        for (let xKey in request.getHeaders()) {
            xhr.setRequestHeader(xKey, request.getHeaders()[xKey]);
        }
        xhr.onload = function (e) {
            if (Utils.isSessionExpiredResponse(this.response)) {
                //Utils.redirectOnSessionError();
                //return;
            }
            if (this.status == 200) {
                if (request.getSuccess()) {
                    request.getSuccess()(this.response);
                }
            } else if (this.status == 401 && !request.getIsRefresh()) {
                FetchService.execute_refreshAccessToken(request);
            } else if (request.getFail()) {
                request.getFail()(this.response);
            }
        };
        if (request.getBody()) {
            xhr.send(request.getBody());
        } else {
            xhr.send();
        }
    }

    public static execute_refreshAccessToken(oldRequest: Request): void {

        const request = new Request();
        request.setIsRefresh(true);
        request.setUrl("oauth/token");
        request.setSuccess((response) => {
            let data = JSON.parse(response);
            localStorage.setItem(this.getNuSecHidden(), data.access_token);
            localStorage.setItem(this.getNuSecHidden() + '-refresh', data.refresh_token);
            this.executeEndpoint(oldRequest);
        });
        request.setFail((response) => {
            localStorage.removeItem(this.getNuSecHidden());
            localStorage.removeItem(this.getNuSecHidden() + '-refresh');
            if (oldRequest.getFail()) {
                oldRequest.getFail()(response);
            }
            //Utils.redirectOnSessionError();
        });
        request.setBody("grant_type=refresh_token&refresh_token=" + this.getRefresh_token());
        request.setMethod("POST");

        request.setHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'deyel-agent': 'Deyel',
            'Accept': '*/*',
            'Authorization': 'Basic ' + btoa(this.getUserCode() + ":")
        });
        this.executeEndpoint(request);
    }

    private static getUserCode(): string {
        let cdUserHidden = (<HTMLInputElement>document.getElementById('cdUserHidden'));
        if (cdUserHidden == null) {
            return this.dX(
                (<HTMLInputElement>document.getElementById("n_AE")).value,
                "uRW3055CT_0yryfgWSnmTKq_wpWsRw5fVe",
            );
        } else {
            return cdUserHidden.value;
        }

    }

    private static dX(cT, k) {
        const cB = Uint8Array.from(atob(cT), (c) => c.charCodeAt(0));
        const kB = new TextEncoder().encode(k);
        const out = new Uint8Array(cB.length);
        for (let i = 0; i < cB.length; i++) {
            out[i] = cB[i] ^ kB[i % kB.length];
        }
        return new TextDecoder("utf-8").decode(out);
    }

    public static getNuSecHidden(): string {
        let nuSecHidden = (<HTMLInputElement>document.getElementById('nuSecHidden'));
        if (nuSecHidden == null) {
            let nuSecHiddenVal = <string>document.getElementsByTagName("head")[0].getAttribute("nuSecHidden");
            if (nuSecHiddenVal != null) {
                return nuSecHiddenVal;
            }

            if (window && window.parent) {
                nuSecHidden = <HTMLInputElement>window.parent.document.getElementById('nuSecHidden');
            }
            if (!window || !window.parent || !nuSecHidden) {
                return null;
            }
        }
        return nuSecHidden.value;
    }

    public static getAccessToken(): string {
        return localStorage.getItem(this.getNuSecHidden());
    }

    public static getRefresh_token(): string {
        return localStorage.getItem(this.getNuSecHidden() + '-refresh');
    }




}
